import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getRateTableNameAndDescriptionById = {
  name: "getRateTableNameAndDescriptionById" as const,
  input: z.object({ rateTableId: zExt.objectId() }),
  output: z.object({
    description: z.string().optional(),
    name: z.string().optional(),
  }),
};
